export default __webpack_public_path__ + "static/media/sightXLogo.8ac4364e.svg";